import React, {useCallback, useEffect, useRef, useState} from "react";
import {useSwipeable} from "react-swipeable";
import {createPortal} from "react-dom";
import styles from "../../VpnActive/VpnActive.module.css";
import QRCode from "react-qr-code";
import {Container} from "../VpnSettingsSelector";
import {AnimatePresence} from "framer-motion";
import {useHaptic} from "../../../Hooks/useHaptic";
import styled from "styled-components";
import {UIButtons} from "../ProMode";

const QrPortal = (
    {
        setShowQrCodePortal,
        config
    }
) => {
    const handlers = useSwipeable({
        onSwipedDown: () => {
            window.Telegram.WebApp.HapticFeedback.selectionChanged();
            setShowQrCodePortal(false);

        },
        preventDefaultTouchmoveEvent: true
    });

    return createPortal(
        <>

            <Container setShowItemSelector={setShowQrCodePortal}>
                {/*<span className={styles.swipe_item}/>*/}
                <div style={{
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    position: 'relative',
                    top: '0px',
                    padding: '16px'
                }}>
                    <h1 style={{fontSize: 24}}>Your QR</h1>
                    <button style={{
                        display: "flex",
                        width: "40px",
                        height: "40px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        borderRadius: "50px",
                        background: "rgba(255, 255, 255, 0.10)",
                        right: '0px',
                        position: 'absolute'
                    }}
                            onClick={() => {
                                setShowQrCodePortal(false);

                            }}
                    >
                        <svg style={{width: "16px", height: "16px", flexShrink: "0"}}
                             xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                             fill="none">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M15.3327 2.39346L2.39151 15.3346L0.666016 13.6091L13.6072 0.667969L15.3327 2.39346Z"
                                  fill="white"/>
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M13.6072 15.3346L0.666016 2.39346L2.39151 0.667969L15.3327 13.6091L13.6072 15.3346Z"
                                  fill="white"/>
                        </svg>
                    </button>
                </div>
                <div className={styles.scan_qr_wrapper}>
                    <div className={styles.scan_qr}>
                        <QRCode
                            className={styles.qr_code__qr_img}
                            value={config}
                            size={256}
                            style={{padding: 5, backgroundColor: 'white'}}
                        />
                    </div>
                    <p style={{
                        fontSize: 16,
                        fontWeight: 400,
                        textAlign: "center",
                        flex: "1 0 0",
                        opacity: 0.5
                    }}>Scan
                        this
                        QR code with another device to
                        connect to the VPN.</p>
                </div>
            </Container>
        </>, document.body
    )
}




export const QrCodeEx = (
    {
        showQrCodePortal,
        setShowQrCodePortal,
        config
    }
) => {

    const {hapticFeedBack} = useHaptic("success")
    return (
        <>
            <UIButtons
                style={{
                    flex: 1
                }}
                onClick={() => {
                    setShowQrCodePortal(true)
                    hapticFeedBack();
                }}>Show QR
            </UIButtons>
            <AnimatePresence>
                {showQrCodePortal && <QrPortal
                    setShowQrCodePortal={setShowQrCodePortal}
                    config={config}
                />}
            </AnimatePresence>
        </>
    )
}


